/**
 * @package citrus.vue.vue-form.message
 */
import {Vue} from "ui.vue";

Vue.component("CitrusVueFormMessage", {
	template: `
		<div class="message" :class="[{error: !success}, {success: success}]" v-if="needShow">
			<slot name="messageTemplate" v-if="useCustomTemplate"></slot>
			<template v-else>
				<svg class="successful_icon" v-if="!success">
					<use x="0" y="0" xlink:href="#warning"/>
				</svg>
				<svg class="successful_icon" v-else>
					<use x="0" y="0" xlink:href="#successful"/>
				</svg>
				<label v-html="message"></label>
			</template>
		</div>
	`,
	props: {
		useCustomTemplate: {
			type: [Boolean],
			default: false
		},
		success: {
			type: [Boolean],
			default: false
		},
		message: {
			type: [Boolean, String],
			default: false
		}
	},
	computed: {
		needShow() {
			return false !== this.message;
		}
	}
});
